<h3 mat-dialog-title>{{data?.title}}</h3>
<div mat-dialog-content>
  {{data?.message}}
</div>
<div class="dialog-actions">
  <button mat-raised-button color="primary" style="color: black !important;margin-right: 8px;" [mat-dialog-close]="true">Run</button>
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
</div>


